import React, { useState } from "react";
import ReportBuilder from "./ReportBuilder";
import ReportDashboard from "./ReportDashboard";
import ReportEditor from "./ReportEditor";
import "./App.css";

function App() {
  const [currentView, setCurrentView] = useState("dashboard"); // "dashboard", "builder", "editor"
  const [editingReport, setEditingReport] = useState(null);

  const handleCreateNew = () => {
    setEditingReport(null);
    setCurrentView("builder");
  };

  const handleEditReport = (report) => {
    setEditingReport(report);
    setCurrentView("editor");
  };

  const handleSaveComplete = (savedReport) => {
    // After saving, go back to dashboard
    setCurrentView("dashboard");
    setEditingReport(null);
  };

  const handleCancel = () => {
    setCurrentView("dashboard");
    setEditingReport(null);
  };

  const renderCurrentView = () => {
    switch (currentView) {
      case "builder":
        return (
          <ReportBuilder 
            onSave={handleSaveComplete}
            onCancel={handleCancel}
          />
        );
      case "editor":
        return (
          <ReportEditor 
            report={editingReport}
            onSave={handleSaveComplete}
            onCancel={handleCancel}
          />
        );
      case "dashboard":
      default:
        return (
          <ReportDashboard 
            onEditReport={handleEditReport}
            onCreateNew={handleCreateNew}
          />
        );
    }
  };

  const getPageTitle = () => {
    switch (currentView) {
      case "builder":
        return "Create New Report";
      case "editor":
        return `Edit Report: ${editingReport?.title || "Untitled"}`;
      case "dashboard":
      default:
        return "Dashboard";
    }
  };

  return (
    <div className="App">
      {/* GEP Navigation Header */}
      <header style={{
        backgroundColor: "#343a40",
        color: "white",
        padding: "15px 20px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        position: "sticky",
        top: 0,
        zIndex: 1000
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          maxWidth: "1200px",
          margin: "0 auto"
        }}>
          {/* Logo and Title */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <img 
              src="/GEP-Logo.png" 
              alt="GEP Contractors Logo" 
              style={{ 
                height: "40px", 
                marginRight: "15px",
                objectFit: "contain"
              }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
            <div>
              <h1 style={{ 
                margin: 0, 
                fontSize: "20px", 
                fontWeight: "bold" 
              }}>
                GEP Photo Report Generator
              </h1>
              <p style={{ 
                margin: 0, 
                fontSize: "12px", 
                opacity: 0.8 
              }}>
                Professional Construction Reports
              </p>
            </div>
          </div>

          {/* Navigation */}
          <nav style={{ display: "flex", gap: "15px", alignItems: "center" }}>
            <button
              onClick={() => setCurrentView("dashboard")}
              style={{
                backgroundColor: currentView === "dashboard" ? "#007bff" : "transparent",
                color: "white",
                border: "1px solid #007bff",
                padding: "8px 15px",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "14px",
                transition: "all 0.2s"
              }}
              onMouseEnter={(e) => {
                if (currentView !== "dashboard") {
                  e.target.style.backgroundColor = "#007bff";
                }
              }}
              onMouseLeave={(e) => {
                if (currentView !== "dashboard") {
                  e.target.style.backgroundColor = "transparent";
                }
              }}
            >
              📊 Dashboard
            </button>
            
            <button
              onClick={handleCreateNew}
              style={{
                backgroundColor: currentView === "builder" ? "#28a745" : "transparent",
                color: "white",
                border: "1px solid #28a745",
                padding: "8px 15px",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "14px",
                transition: "all 0.2s"
              }}
              onMouseEnter={(e) => {
                if (currentView !== "builder") {
                  e.target.style.backgroundColor = "#28a745";
                }
              }}
              onMouseLeave={(e) => {
                if (currentView !== "builder") {
                  e.target.style.backgroundColor = "transparent";
                }
              }}
            >
              ➕ New Report
            </button>
          </nav>
        </div>
      </header>

      {/* Breadcrumb */}
      <div style={{
        backgroundColor: "#f8f9fa",
        padding: "10px 20px",
        borderBottom: "1px solid #dee2e6"
      }}>
        <div style={{
          maxWidth: "1200px",
          margin: "0 auto",
          fontSize: "14px",
          color: "#666"
        }}>
          <span>🏠 Home</span>
          <span style={{ margin: "0 8px" }}>›</span>
          <span style={{ color: "#007bff", fontWeight: "bold" }}>
            {getPageTitle()}
          </span>
        </div>
      </div>

      {/* Main Content */}
      <main style={{
        maxWidth: "1200px",
        margin: "0 auto",
        minHeight: "calc(100vh - 140px)"
      }}>
        {renderCurrentView()}
      </main>

      {/* Footer */}
      <footer style={{
        backgroundColor: "#343a40",
        color: "white",
        textAlign: "center",
        padding: "20px",
        marginTop: "40px"
      }}>
        <div style={{
          maxWidth: "1200px",
          margin: "0 auto"
        }}>
          <p style={{ margin: "0 0 10px 0", fontSize: "14px" }}>
            © 2024 GEP Contractors - Professional Photo Report Generator
          </p>
          <p style={{ margin: 0, fontSize: "12px", opacity: 0.8 }}>
            Powered by advanced image optimization and cloud storage
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;

